import { useUserEvaluation } from "../../user/hooks/useUserEvaluation";
import { useEmployeesMinimal } from "../../employees/hooks/useEmployeesMinimal";

export function useStartEvaluationData() {
  const { userEvaluation, loadingUserEvaluation, errorUserEvaluation } = useUserEvaluation();
  const { employeesMinimal, loadingEmployeesMinimal, errorEmployeesMinimal } = useEmployeesMinimal();

  const loading = loadingUserEvaluation || loadingEmployeesMinimal;
  const error = errorUserEvaluation || errorEmployeesMinimal;

  return {
    loading,
    error,
    userEvaluation,
    employeesMinimal,
    loadingUserEvaluation,
    loadingEmployeesMinimal,
  };
}
